import * as z from "zod";

export const levelNameSchema = z.enum(["childhood", "elementary", "secondary", "fga", "fp", "collegial"]);
export type LevelName = z.infer<typeof levelNameSchema>;
export const levelLabels: Record<LevelName, string> = {
  childhood: wp.i18n.__("Early childhood", "egalite"),
  elementary: wp.i18n.__("Elementary school", "egalite"),
  secondary: wp.i18n.__("Secondary school", "egalite"),
  fga: wp.i18n.__("Adult education", "egalite"),
  fp: wp.i18n.__("Vocational training", "egalite"),
  collegial: wp.i18n.__("College", "egalite"),
} as const;

export const workshopNameSchema = z.enum(["activities", "games", "childhood_development", "professional_development", "discourses", "dress_codes", "environments", "literacy", "parents", "tools"]);
export type WorkshopName = z.infer<typeof workshopNameSchema>;

export const childhookWorkshopLabels: Partial<Record<WorkshopName, string>> = {
  games: wp.i18n.__("Activities, games and welcoming children", "egalite"),
  literacy: wp.i18n.__("Early literacy", "egalite"),
  parents: wp.i18n.__("Working with parents", "egalite"),
  childhood_development: wp.i18n.__("Professional development", "egalite"),
} as const;

export const generalWorkshopLabels: Partial<Record<WorkshopName, string>> = {
  discourses: wp.i18n.__("Masculinist discourses", "egalite"),
  dress_codes: wp.i18n.__("Dress codes", "egalite"),
  environments: wp.i18n.__("Inclusive learning environments", "egalite"),
} as const;

export const professionalWorkshopLabels: Partial<Record<WorkshopName, string>> = {
  professional_development: wp.i18n.__("Professional development", "egalite"),
  activities: wp.i18n.__("Activities", "egalite"),
  tools: wp.i18n.__("Institutional tools", "egalite"),
} as const;

export const workshopLabels = {
  ...childhookWorkshopLabels,
  ...generalWorkshopLabels,
  ...professionalWorkshopLabels,
} as const;
